import React, { useState, useEffect, useCallback } from "react";
import moment from 'moment';
import { toast } from 'react-toastify';

/* for "axios" request cancelation */
import axios from 'axios';

/* Helpers */
import { history } from '../../../helpers/history';
import 'moment/locale/tr';

/* Services */
import DoctorService from "../../../services/doctor.service";

/* Ant Design */
import { Typography, Table, Button, Row, Col, Tag, Card, List, Image, Popconfirm, Space, Input, Pagination } from 'antd';

/* for "axios" request cancelation check variable */
let source;

const DoctorPrescriptions = (props) => {
    const [prescriptions, setPrescriptions] = useState([]);
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [totalCount, setTotalCount] = useState(0);
    const [search, setSearch] = useState(null);
    const [loading, setLoading] = useState(false);
    const [tableLoading, setTableLoading] = useState(true);
    const [disableNewPrescriptionButton, setDisableNewPrescriptionButton] = useState(false);
    const [expandedRowKeys, setExpandedRowKeys] = useState([]);

    const getExactQuery = useCallback((() => {
        const query = new URLSearchParams(props.location.search);
        const reqSearch = query.get('search');
        const reqStatus = query.get('status');
        const reqSortByDate = query.get('sortbydate');
        const reqPage = query.get('page');
        const reqLimit = query.get('limit');
        const exactQuery = {};

        reqStatus && (exactQuery.status = reqStatus);
        reqSearch && (exactQuery.search = reqSearch);
        reqSortByDate && (exactQuery.sortbydate = reqSortByDate);
        reqPage && (exactQuery.page = reqPage);
        reqLimit && (exactQuery.limit = reqLimit);

        return exactQuery;
    }), [props.location.search]);

    useEffect(() => {
        source = axios.CancelToken.source();

        getPrescriptions(getExactQuery(), source.token);
        return () => {
            if (source) {
                source.cancel();
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const prescriptionColumns = [
        /* Hasta AdSoyad */
        {
            title: 'Hasta',
            dataIndex: 'HastaAdSoyad',
            key: 'HastaAdSoyad',
            sorter: (a, b) => a.HastaAdSoyad.localeCompare(b.HastaAdSoyad),
            sortDirections: ['descend', 'ascend', 'descend'],
            responsive: ["xs", "sm", "md", "lg"]
        },
        /* Ebeveyn AdSoyad */
        {
            title: 'Ebeveyn',
            dataIndex: 'EbeveynAdSoyad',
            key: 'EbeveynAdSoyad',
            sorter: (a, b) => a.EbeveynAdSoyad.localeCompare(b.EbeveynAdSoyad),
            sortDirections: ['descend', 'ascend', 'descend'],
            responsive: ["xs", "sm", "md", "lg"]
        },
        /* KayitTarihi */
        {
            title: 'Reçete Tarihi',
            dataIndex: 'ReceteTarihi',
            key: 'ReceteTarihi',
            defaultSortOrder: 'ascend',
            sorter: (a, b) => new Date(a.ReceteTarihi) - new Date(b.ReceteTarihi),
            sortDirections: ['ascend', 'descend', 'ascend'],
            render: (ReceteTarihi) => (
                moment(new Date(ReceteTarihi)).format('LL')
            ),
            responsive: ["lg"]
        },
        /* Reçete Açıklama */
        {
            title: 'Reçete Açıklama',
            dataIndex: 'ReceteAciklama',
            key: 'ReceteAciklama',
            responsive: ["xs", "sm", "md", "lg"]
        },
        /* Durum */
        {
            title: 'Durum',
            dataIndex: 'AktifMi',
            key: 'Durum',
            sorter: (a, b) => a.AktifMi - b.AktifMi,
            sortDirections: ['ascend', 'descend', 'ascend'],
            render: (AktifMi) => (
                AktifMi === true ?
                    <Tag color={'success'}>
                        Aktif
                    </Tag>
                    :
                    <Tag color={'error'}>
                        Pasif
                    </Tag>
            ),
            responsive: ["xs", "sm", "md", "lg"]
        },
        /* PasifTarihi */
        {
            title: 'Pasif Tarihi',
            dataIndex: 'PasifTarihi',
            key: 'PasifTarihi',
            sorter: (a, b) => new Date(a.PasifTarihi) - new Date(b.PasifTarihi),
            sortDirections: ['ascend', 'descend', 'ascend'],
            render: (PasifTarihi) => (
                PasifTarihi <= (new Date('1923-10-29')) ?
                    <Typography.Text>-</Typography.Text>
                    :
                    PasifTarihi = moment(new Date(PasifTarihi)).format('LL')
            ),
            responsive: ["lg"]
        },
        /* Actions */
        {
            title: 'İşlemler',
            dataIndex: '',
            key: 'x',
            render: (text, record) => (
                <Row gutter={{ xs: 32, sm: 24, md: 16, lg: 8 }}>
                    {/* Reçete Görüntüle */}
                    <Col className="gutter-row">
                        <Button
                            block
                            type="primary"
                            ghost
                            style={{ whiteSpace: "normal", height: 'auto', marginBottom: '10px' }}
                            onClick={
                                () => {
                                    props.history.push("/doctor/patients/actions/prescriptions/" + record.key);
                                }
                            }
                        >
                            Görüntüle
                        </Button>
                    </Col>
                    {/* Aktif Reçete Pasifleştir */}
                    {(record.AktifMi === true) &&
                        <Col className="gutter-row">
                            <Popconfirm title="Reçeteyi pasifleştirmek istediğinize emin misiniz?" onConfirm={() => passivationPrescription(record.key)}>
                                <Button type="primary" block danger>Pasifleştir</Button>
                            </Popconfirm>
                        </Col>
                    }
                </Row>
            ),
            responsive: ["xs", "sm", "md", "lg"]
        },
    ];

    const getPrescriptions = (query, cancelToken) => {
        setTableLoading(true);
        setDisableNewPrescriptionButton(false);

        DoctorService.getDoctorPrescriptions(query, cancelToken)
            .then(
                (res) => {
                    let query = '?page=' + res.data.page + '&limit=' + res.data.limit;
                    res.data.search && (query += "&search=" + res.data.search);
                    res.data.status && (query += "&status=" + res.data.status);
                    res.data.sortbydate && (query += "&sortbydate=" + res.data.sortbydate);

                    props.history.push({
                        pathname: '',
                        search: query
                    });
                    let prescriptions = res.data.Prescriptions?.map((prescription) => {
                        //Reçete aktif olduğunda "PasifTarihi = null" olacağı için Invalid date yerine geçmiş bir tarih uygulandı
                        moment(prescription.PasifTarihi).toString() === 'Invalid date' ?
                            prescription.PasifTarihi = new Date('1923-10-29')
                            :
                            prescription.PasifTarihi = new Date(prescription.PasifTarihi);

                        if (prescription.AktifMi === true) {
                            setDisableNewPrescriptionButton(true);
                        }

                        return {
                            ...prescription,
                            key: prescription._id,
                            HastaAdSoyad: prescription.HastaID.AdSoyad,
                            EbeveynAdSoyad: prescription.HastaID.EbeveynID.AdSoyad,
                            ReceteTarihi: moment(prescription.ReceteTarihi).toString(),
                            PasifTarihi: prescription.PasifTarihi,
                        }
                    });
                    setPrescriptions([...prescriptions]);

                    setPage(res.data.page);
                    setLimit(res.data.limit);
                    setTotalCount(res.data.totalCount);
                    setTableLoading(false);
                },
                (error) => {
                    const resMessage =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();

                    if (resMessage !== 'Cancel') {
                        toast.error(resMessage, { autoClose: 3000 });
                        setTableLoading(false);
                    }
                })
    }

    const passivationPrescription = (prescriptionId) => {
        setLoading(true);

        DoctorService.passivationPrescription(prescriptionId)
            .then(
                (res) => {
                    toast.success(res.data.message, { autoClose: 3000 });
                    getPrescriptions(getExactQuery(), source.token);
                },
                (error) => {
                    const resMessage =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();

                    /* Request cancel edildiğinde message olarak 'Cancel' dönüyor. Hata bildirimi verilmesini engellemek için */
                    if (resMessage !== 'Cancel') {
                        toast.error(resMessage, { autoClose: 3000 });
                    }
                    setLoading(false);
                    getPrescriptions(getExactQuery(), source.token);
                })
    }

    const onTableRowExpand = (expanded, record) => {
        var keys = [];
        if (expanded) {
            keys.push(record._id);
        }

        setExpandedRowKeys([...keys]);
    }

    const onChangePage = (page, limit) => {
        const query = new URLSearchParams(props.location.search);
        const queryPage = query.get('page');
        const queryLimit = query.get('limit');
        if (parseInt(page) < 1) {
            page = 1;
        }
        if (parseInt(limit) < 10) {
            limit = 10;
        }
        if ((parseInt(page) !== parseInt(queryPage)) || (parseInt(limit) !== parseInt(queryLimit))) {
            let query = getExactQuery();
            query.page = page;
            query.limit = limit;
            getPrescriptions(query, source.token);
        }
    }

    const Search = (value) => {
        setSearch(value);
        let query = getExactQuery();
        query.search = value;
        getPrescriptions(query, source.token);
    };

    let gamesCount = 0;

    return (
        <div>
            <Typography.Title style={{ textAlign: 'center' }}>
                Reçeteler
            </Typography.Title>
            {/* for Search */}
            <Space direction="horizontal" align="center" style={{ width: '100%', justifyContent: 'center', marginBottom: '5vh' }}>
                <Input.Search
                    placeholder="Hasta İsmi veya T.C. No. ile Arama Yapabilirsiniz."
                    defaultValue={search}
                    onSearch={Search}
                    enterButton
                    allowClear={true}
                    style={{
                        width: 400
                    }}
                    loading={tableLoading}
                />
            </Space>
            {prescriptions.length > 0 &&
                <div>
                    <Space direction="horizontal" align="end" style={{ width: '100%', justifyContent: 'right' }}>
                        <Typography.Text><b>{prescriptions.length}&nbsp;/&nbsp;{totalCount}</b> Adet Reçete Listelendi!</Typography.Text>
                    </Space>
                </div>
            }
            <Table
                columns={prescriptionColumns}
                dataSource={prescriptions && prescriptions}
                expandable={{
                    expandedRowRender: record => (
                        <div>
                            <Card style={{ marginTop: 16, backgroundColor: '#e6f7ff' }} loading={loading}>
                                <Typography.Title level={4}>
                                    Hasta Bilgileri
                                </Typography.Title>
                                {record.HastaID.AdSoyad &&
                                    <List size="larger" bordered>
                                        {/* İsim - Doğum Tarihi */}
                                        <List.Item>
                                            <Row gutter={[8, 32]} style={{ width: '100%' }}>
                                                <Col span={12}>
                                                    <Typography.Text style={{ fontWeight: 'bold' }}>İsim: </Typography.Text>
                                                    <Typography.Text>{record.HastaID.AdSoyad}</Typography.Text>
                                                </Col>
                                                <Col span={12}>
                                                    <Typography.Text style={{ fontWeight: 'bold' }}>Doğum Tarihi: </Typography.Text>
                                                    <Typography.Text>{moment(new Date(record.HastaID.DogumTarihi)).format('LL')}</Typography.Text>
                                                </Col>
                                            </Row>
                                        </List.Item>
                                        {/* Cinsiyet - Yaş */}
                                        <List.Item>
                                            <Row gutter={[8, 32]} style={{ width: '100%' }}>
                                                <Col span={12}>
                                                    <Typography.Text style={{ fontWeight: 'bold' }}>Cinsiyet: </Typography.Text>
                                                    <Typography.Text>{record.HastaID.Cinsiyet}</Typography.Text>
                                                </Col>
                                                <Col span={12}>
                                                    <Typography.Text style={{ fontWeight: 'bold' }}>Yaş: </Typography.Text>
                                                    <Typography.Text>{moment().diff(record.HastaID.DogumTarihi, 'years', false)}</Typography.Text>
                                                </Col>
                                            </Row>
                                        </List.Item>
                                    </List>
                                }
                                <p style={{ display: 'none' }}>{gamesCount = 0}</p>
                                <br />
                                <Typography.Title level={5}>
                                    Oyun Bilgileri
                                </Typography.Title>
                                {record.Oyunlar &&
                                    (record.Oyunlar.map(oyun => (
                                        <div key={oyun._id}>
                                            <Row type="flex" gutter={[8, 8]} style={{ width: '100%', alignItems: 'center' }}>
                                                <Col xs={24} md={24} lg={8} xl={5}>
                                                    <Image
                                                        preview={false}
                                                        width={'100%'}
                                                        src={oyun.OyunID.PhotoLink}
                                                        alt={oyun.OyunID.OyunAdi}
                                                        fallback="data:image/png;base64,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"
                                                    />
                                                </Col>
                                                <Col xs={24} md={24} lg={16} xl={19}>
                                                    <List size="larger" style={((gamesCount + 1) % 2 === 0) ? { backgroundColor: '#FFFFFF' } : { backgroundColor: '#E8E8E8' }} bordered>
                                                        {/* İsim - Hafta - Durum */}
                                                        <List.Item>
                                                            <Row gutter={[8, 32]} style={{ width: '100%' }}>
                                                                <Col span={12}>
                                                                    <Typography.Text style={{ fontWeight: 'bold' }}>#{gamesCount += 1}&emsp;İsim: </Typography.Text>
                                                                    <Typography.Text>{oyun.OyunID.OyunAdi}</Typography.Text>
                                                                </Col>
                                                                {oyun.Hafta &&
                                                                    <Col span={8}>
                                                                        <Typography.Text style={{ fontWeight: 'bold' }}>Hafta: </Typography.Text>
                                                                        <Typography.Text>{oyun.Hafta} Hafta</Typography.Text>
                                                                    </Col>
                                                                }
                                                                {oyun.OyunID &&
                                                                    <Col span={4}>
                                                                        <Typography.Text style={{ fontWeight: 'bold' }}>Durum: </Typography.Text>
                                                                        {
                                                                            oyun.OyunID.Free === true ?
                                                                                <Tag color="green">Ücretsiz</Tag>
                                                                                :
                                                                                <Tag color="red">Ücretli</Tag>
                                                                        }
                                                                    </Col>
                                                                }
                                                            </Row>
                                                        </List.Item>
                                                        {/* Açıklama - Haftada Kaç Gün */}
                                                        <List.Item>
                                                            <Row gutter={[8, 32]} style={{ width: '100%' }}>
                                                                <Col span={12}>
                                                                    <Typography.Text style={{ fontWeight: 'bold' }}>Açıklama: </Typography.Text>
                                                                    <Typography.Text>{oyun.OyunID.OyunAciklama}</Typography.Text>
                                                                </Col>
                                                                {oyun.HaftadaKacGun &&
                                                                    <Col span={12}>
                                                                        <Typography.Text style={{ fontWeight: 'bold' }}>Haftada Kaç Gün: </Typography.Text>
                                                                        <Typography.Text>{oyun.HaftadaKacGun} Gün</Typography.Text>
                                                                    </Col>
                                                                }
                                                            </Row>
                                                        </List.Item>
                                                        {/* Kategori - Günde Kaç Kez */}
                                                        <List.Item>
                                                            <Row gutter={[8, 32]} style={{ width: '100%' }}>
                                                                {oyun.OyunID.KategoriID &&
                                                                    <Col span={12}>
                                                                        <Typography.Text style={{ fontWeight: 'bold' }}>Kategori: </Typography.Text>
                                                                        <Tag color="volcano">{oyun.OyunID.KategoriID.KategoriAdi}</Tag>
                                                                    </Col>
                                                                }
                                                                {oyun.GundeKacKez &&
                                                                    <Col span={12}>
                                                                        <Typography.Text style={{ fontWeight: 'bold' }}>Günde Kaç Kez: </Typography.Text>
                                                                        <Typography.Text>{oyun.GundeKacKez} Kere</Typography.Text>
                                                                    </Col>
                                                                }
                                                            </Row>
                                                        </List.Item>
                                                        {/* Egzersiz Tipi - Oyun Süresi */}
                                                        <List.Item>
                                                            <Row gutter={[8, 32]} style={{ width: '100%' }}>
                                                                {oyun.OyunID.EgzersizTipiID &&
                                                                    <Col span={12}>
                                                                        <Typography.Text style={{ fontWeight: 'bold' }}>Egzersiz Tipi: </Typography.Text>
                                                                        <Tag color="magenta">{oyun.OyunID.EgzersizTipiID.EgzersizTipiAdi}</Tag>
                                                                    </Col>
                                                                }
                                                                {oyun.OyunSuresi &&
                                                                    <Col span={12}>
                                                                        <Typography.Text style={{ fontWeight: 'bold' }}>Oyun Süresi: </Typography.Text>
                                                                        <Typography.Text>{oyun.OyunSuresi} Dakika</Typography.Text>
                                                                    </Col>
                                                                }
                                                            </Row>
                                                        </List.Item>
                                                        {/* Reçete Oyun Açıklaması */}
                                                        <List.Item>
                                                            <Row gutter={[8, 32]} style={{ width: '100%' }}>
                                                                {oyun.OyunAciklama &&
                                                                    <Col span={24}>
                                                                        <Typography.Text style={{ fontWeight: 'bold' }}>Reçete Oyun Açıklaması: </Typography.Text>
                                                                        <Typography.Text>{oyun.OyunAciklama}</Typography.Text>
                                                                    </Col>
                                                                }
                                                            </Row>
                                                        </List.Item>
                                                    </List>
                                                </Col>
                                            </Row>
                                            <br />
                                        </div>
                                    )))
                                }
                            </Card>
                        </div>
                    ),
                    rowExpandable: record => record.AdSoyad !== 'Not Expandable',
                }}
                expandedRowKeys={expandedRowKeys}
                onExpand={onTableRowExpand}
                loading={tableLoading}
                pagination={false}
            />
            {/* for Pagination */}
            <Space direction="horizontal" align="end" style={{ width: '100%', justifyContent: 'right' }}>
                <Pagination
                    hideOnSinglePage={true}
                    defaultCurrent={1}
                    total={totalCount}
                    pageSizeOptions={[10, 20, 50]}
                    showSizeChanger={true}
                    onChange={(page, limit) => onChangePage(page, limit)}
                    style={{ marginTop: '16px' }}
                />
            </Space>
        </div>
    )
}

export default DoctorPrescriptions;